import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const UserService = {
  getUserById: (userId: string) =>
    requests(SERVICE_NAME.USERS_API).get(`${userId}`),

  deleteUserById: (userId: string) =>
    requests(SERVICE_NAME.USERS_API).delete(`${userId}`),
};

export default UserService;
